<div class="container">
    <app-title-content [title]="title"></app-title-content>

    <div class="section">
        <div class="nav nav-tabs mt-4">
            <div class="nav-item">
                <button (click)="tab = 0" class="nav-link" [ngClass]="{'active' : tab === 0}">ข้อมูลทั่วไป</button>
            </div>
            <div class="nav-item">
                <button (click)="tab = 1" class="nav-link" [ngClass]="{'active' : tab === 1}">ประวัติเข้าร่วมเควส</button>
            </div>
            <div class="nav-item">
                <button (click)="tab = 2" class="nav-link" [ngClass]="{'active' : tab === 2}">ประวัติเข้าร่วมแคมเปญ</button>
            </div>
            <div class="nav-item">
                <button (click)="tab = 3" class="nav-link" [ngClass]="{'active' : tab === 3}">ประวัติใช้ E-coupon</button>
            </div>
            <div class="nav-item">
                <button (click)="tab = 4" class="nav-link" [ngClass]="{'active' : tab === 4}">Assistant PC</button>
            </div>
        </div>

        <div *ngIf="tab === 0" class="card py-3">
            <span class="title-card">{{title}}</span>
            <div class="row body-card">
                <div class="col-lg-6 col-md-12 item">
                    <span>PC ID</span>
                    <span>{{ userData?.users?.id ?? '-'}}</span>
                </div>
                <div class="col-lg-6 col-md-12 item">
                    <span>ชื่อ</span>
                    <span>{{ userData?.users?.fullname ?? '-'}}</span>
                </div>
            </div>
            <div class="row body-card">
                <div class="col-lg-6 col-md-12 item">
                    <span>อีเมล</span>
                    <span>{{ userData?.users?.email ?? '-'}}</span>
                </div>
                <div class="col-lg-6 col-md-12 item">
                    <span>Password</span>
                    <span>{{ userData?.users?.password ?? '-'}}</span>
                </div>
            </div>
            <div class="row body-card">
                <div class="col-lg-6 col-md-12 item">
                    <span>คลินิก</span>
                    <span>{{ userData?.users?.clinic?.name ?? '-'}}</span>
                </div>
                <div class="col-lg-6 col-md-12 item">
                    <span>สาขา</span>
                    <span>{{ userData?.users?.clinic?.branch?.name ?? '-'}}</span>
                </div>
            </div>
            <div class="row body-card">
                <div class="col-lg-6 col-md-12 item">
                    <span>สถานะ</span>
                    <div class="status">
                        <div class="status-active">Active</div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 item">
                    <span>คะแนน</span>
                    <span>{{ userData?.users.points ?? '-'}}</span>
                </div>
            </div>
        </div>

        <!-- campaign -->
        <div *ngIf="tab === 1" class="card py-3">
            <span class="title-card">ประวัติเข้าร่วมเควส</span>
            <div class="row body-card scroll-table">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>ชื่อลูกค้า</th>
                            <th>ชื่อเควส</th>
                            <th>ประเภท</th>
                            <th>วันที่สแกน</th>
                            <th>Assistant PC</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="quests.length == 0">
                            <td colspan="6" class="text-center">ไม่พบข้อมูล</td>
                        </tr>
                        <tr *ngFor="let item of quests; let i = index">
                            <td>{{ item.users?.fullname ?? '-' }}</td>
                            <td>{{ item.quest?.name ?? '-' }}</td>
                            <td>{{ displayRewardType(item.quest?.rewardType) }}</td>
                            <td>{{ item.createdAt ? (item.createdAt | date:'dd/MM/yyyy - HH:SS น.' : 'UTC') : '-' }}</td>
                            <td>{{ item.assistantPc ?? '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- ใช้คอมโพเนนต์ Pagination -->
            <app-pagination [totalItems]="paginationQuest.totalItems" [currentPage]="paginationQuest.currentPage" [itemsPerPage]="paginationQuest.itemsPerPage"
                (pageChange)="onPageChange($event, 'quest')">
            </app-pagination>
        </div>

        <!-- quest -->
        <div *ngIf="tab === 2" class="card py-3">
            <span class="title-card">ประวัติเข้าร่วมแคมเปญ</span>
            <div class="row body-card scroll-table">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>ชื่อลูกค้า</th>
                            <th>ชื่อแคมเปญ</th>
                            <th>วันที่เข้าร่วม</th>
                            <th>คะแนนที่ได้</th>
                            <th>Assistant PC</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="campaigns.length == 0">
                            <td colspan="6" class="text-center">ไม่พบข้อมูล</td>
                        </tr>
                        <tr *ngFor="let item of campaigns; let i = index">
                            <td>{{ item.users?.fullname ?? '-' }}</td>
                            <td>{{ item.campaign?.name ?? '-' }}</td>
                            <td>{{ item.createdAt ? (item.createdAt | date:'dd/MM/yyyy - HH:SS น.' : 'UTC') : '-' }}</td>
                            <td>{{ item.campaign?.point ? item.campaign.point : '-' }}</td>
                            <td>{{ item.assistantPc ?? '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- ใช้คอมโพเนนต์ Pagination -->
            <app-pagination [totalItems]="paginationCampaign.totalItems" [currentPage]="paginationCampaign.currentPage" [itemsPerPage]="paginationCampaign.itemsPerPage"
                (pageChange)="onPageChange($event, 'campaign')">
            </app-pagination>
        </div>

        <!-- e-coupon -->
        <div *ngIf="tab === 3" class="card py-3">
            <span class="title-card">ประวัติใช้ E-coupon</span>
            <div class="row body-card scroll-table">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th>ชื่อลูกค้า</th>
                            <th>ชื่อคูปอง</th>
                            <th>ประเภท</th>
                            <th>วันที่สแกน</th>
                            <th>Assistant PC</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="ecoupons.length == 0">
                            <td colspan="6" class="text-center">ไม่พบข้อมูล</td>
                        </tr>
                        <tr *ngFor="let item of ecoupons; let i = index">
                            <td>{{ item.user?.fullname ?? '-' }}</td>
                            <td>{{ item.coupon?.name ?? '-' }}</td>
                            <td>{{ item.coupon?.type ?? '-' }}</td>
                            <td>{{ item.receiveDate ? (item.receiveDate | date:'dd/MM/yyyy - HH:SS น.' : 'UTC') : '-' }}</td>
                            <td>{{ item.assistantPc ?? '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- ใช้คอมโพเนนต์ Pagination -->
            <app-pagination [totalItems]="paginationCoupon.totalItems" [currentPage]="paginationCoupon.currentPage" [itemsPerPage]="paginationCoupon.itemsPerPage"
                (pageChange)="onPageChange($event, 'coupon')">
            </app-pagination>
        </div>

        <!-- assistant -->
        <div *ngIf="tab === 4" class="card py-3">
            <span class="title-card">ประวัต Assistant PC</span>
            <div class="row body-card scroll-table">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th class="min-w-200px">ชื่อ Assistant PC</th>
                            <th>จำนวนที<br>สแกน e-coupon</th>
                            <th>จำนวนที่<br>สแกน เควส</th>
                            <th>จำนวนที่<br>สแกน camapign</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="assistantPaginationList.length == 0">
                            <td colspan="7" class="text-center">ไม่พบข้อมูล</td>
                        </tr>
                        <tr *ngFor="let item of assistantPaginationList; let i = index">
                            <td>{{ item.assistant_pc ?? '-' }}</td>
                            <td>{{ item.count_e_coupon ?? '-' }}</td>
                            <td>{{ item.count_quest ?? '-' }}</td>
                            <td>{{ item.count_campaign ?? '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- ใช้คอมโพเนนต์ Pagination -->
            <app-pagination [totalItems]="paginationAssistant.totalItems" [currentPage]="paginationAssistant.currentPage"
                [itemsPerPage]="paginationAssistant.itemsPerPage" (pageChange)="onPageChange($event, 'assistant')">
            </app-pagination>
        </div>
    </div>


    <!-- <div class="d-flex justify-content-between mt-4">
        <div>
            <button (click)="delete()" type="button" class="btn btn-outline-danger">ลบผู้ใช้</button>
            <button *ngIf="userData?.status != 'ban'" (click)="checkBanUser()" type="button"
                class="btn btn-outline-danger mx-2">ระงับผู้ใช้</button>
            <button *ngIf="userData?.status == 'ban'" (click)="unbannedUser()" type="button"
                class="btn btn-outline-danger mx-2">คืนสิทให้ผุ้ใช้</button>
        </div>
        <div>
            <button (click)="goBack()" class="btn mx-2">กลับ</button>
            <button (click)="edit()" class="btn btn-primary">แก้ไขผู้ใช้</button>
        </div>
    </div> -->
</div>